/**
 * Build a full CDN URL for a logical asset path (TypeScript mirror of
 * App\Utils\AssetUrl::url()).
 *
 * Base URL is injected at runtime by @layout.latte as window.__ASSETS_BASE__
 * (single source of truth — same SPACES_ASSETS_BASE_URL env var read by
 * BasePresenter::load()). See Phase 48 Plan 03.
 *
 * Usage:
 *   assetUrl('nw/icons/gold.webp')        → "https://<base>/nw/icons/gold.webp"
 *   assetUrl('nw/icons/dungeons/1.png')   → "https://<base>/nw/icons/dungeons/1.png"
 *
 * Logical paths only — no leading `/`, no `assets/` or `public/` prefix.
 */
export function assetUrl(logicalPath: string): string {
    const base = ((window as unknown as { __ASSETS_BASE__?: string }).__ASSETS_BASE__ ?? '').replace(/\/$/, '');
    return `${base}/${logicalPath}`;
}
